var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseGrey2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2998 7.6998C1.1498 7.6998 1.0498 7.6498 0.949805 7.5498C0.749805 7.3498 0.749805 7.0498 0.949805 6.8498L7.3498 0.449805C7.5498 0.249805 7.8498 0.249805 8.0498 0.449805C8.2498 0.649805 8.2498 0.949805 8.0498 1.1498L1.6498 7.5498C1.5498 7.6498 1.4498 7.6998 1.2998 7.6998Z",
    fill: "#858894"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6998 7.6998C7.5498 7.6998 7.4498 7.6498 7.3498 7.5498L0.949805 1.1498C0.749805 0.949805 0.749805 0.649805 0.949805 0.449805C1.1498 0.249805 1.4498 0.249805 1.6498 0.449805L7.9998 6.7998C8.1998 6.9998 8.1998 7.2998 7.9998 7.4998C7.9498 7.6498 7.7998 7.6998 7.6998 7.6998Z",
    fill: "#858894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey2);
export default __webpack_public_path__ + "static/media/close_grey2.851f0d3e2f6059bf320be598c5019477.svg";
export { ForwardRef as ReactComponent };